<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DialogForm',
})
</script>
<template>
  <BdDialog :destroyOnClose="disableCache" :visible="visible" :title="title" :befor-close-fn="triggerClose" :confirm-fn="triggerConfirm">
    <slot name="body" v-bind="{ model }" />
    <BdForm ref="bdFormRef" :row="row" :col="col" :model="model" :schema="schema" :layout="layout" :watch="deepWatch" />
    <template #extraFooter>
      <slot name="extraFooter" v-bind="{ bdFormRef, triggerConfirm }" />
    </template>
  </BdDialog>
</template>
<script lang="ts" setup name="DialogForm">
import { computed, nextTick, ref, watch } from 'vue'
import { BdDialog } from '-/Base/BdDialog'
import { BdForm } from '-/Base/BdForm'
import { DialogFormProps } from './props'
import { message } from 'ant-design-vue'
const props = defineProps(DialogFormProps)
const emits = defineEmits(['update:visible'])
const bdFormRef = ref()

defineExpose({
  validate: () => bdFormRef.value?.validate(),
  clearValidate: () => bdFormRef.value?.clearValidate(),
  resetFields: () => bdFormRef.value?.resetFields(),
  modelRef: computed(() => bdFormRef.value?.modelRef)
})

// const formModel = computed(() => {
//   if (props.visible) {
//     return props.model
//   } else {
//     const res = {}
//     Object.keys(props.model).forEach(key => (res[key] = undefined))
//     return res
//   }
// })
const triggerClose = () => {
  if (props.beforCloseFn !== null) props.beforCloseFn()
  emits('update:visible', false)
}

const triggerConfirm = () => {
  return new Promise((resolve, reject) => {
    bdFormRef.value
      .validate()
      .then(() => {
        props
          .confirmFn(bdFormRef.value.modelRef)
          .then(res => {
            resolve(res)
            bdFormRef.value.clearValidate()
          })
          .catch(err => {
            reject(err)
          })
      })
      .catch(err => {
        reject(err)
        err.errorFields && message.error(err.errorFields[0].errors[0])
      })
  })
}
watch(
  () => props.visible,
  (nVal, oVal) => {
    /* true=>false */
    if (nVal === false && oVal === true) {
      setTimeout(() => {
        bdFormRef.value?.resetFields?.()
        bdFormRef.value?.clearValidate?.()
      }, 100)
    }
    /* false=>true */
    // if (nVal === true && oVal === false) {
    //   setTimeout(() => {
    //     bdFormRef.value.executeDictQueue()
    //   }, 100)
    // }
    if (nVal) {
      nextTick(() => {
        bdFormRef.value.initFields()
      })
    }
  }
)
</script>
